<template>
  <div class="lang-choose">
    <Select class="lang-choose-select" v-model="value" @change="changeLang">
      <option
        v-for="(text, langVal) in realLangList"
        :key="langVal"
        :value="langVal"
      >
        {{ text }}
      </option>
    </Select>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Select from './common/Select.vue';
import { SET_LANG } from '@store/officialSupport';
import { clickButton } from '@plugins/biPoint/_configOfficialSupport';

export default {
  name: 'LangChoose',
  data() {
    return {
      value: ''
    };
  },
  computed: {
    ...mapState({
      curLang: state => state.curLang,
      langList: state => state.langList,
      supportLang: state => state.supportLang
    }),
    realLangList() {
      return Object.keys(this.supportLang).length > 0
        ? this.supportLang
        : this.langList;
    }
  },
  watch: {
    curLang(val, oldVal) {
      this.value = val;
      if (val != oldVal) {
        this.getFaqClassList(true);
        this.getWorkTempList(true);
        this.getFaqNotice();
      }
    }
  },
  methods: {
    ...mapActions(['getFaqClassList', 'getWorkTempList', 'getFaqNotice']),
    changeLang(value) {
      this.$store.commit(SET_LANG, value);
      clickButton({
        btnName: 'clickChooseLang',
        otherParams: {
          lang: value
        }
      });
    }
  },
  created() {
    this.value = this.curLang;
  },
  components: {
    Select
  }
};
</script>

<style lang="scss" scoped>
.lang-choose {
  cursor: pointer;
  &-select {
    height: 24px;
    padding: 0 10px 0 10px;
    border-radius: 12px;
    font-size: 12px;
  }
}
</style>
